/* eslint-disable */
import React, { useContext, useState, useCallback, useRef } from 'react';
import { UserContext } from '../../../App';
import { Link, useNavigate } from 'react-router-dom';
import styles from './search-company.module.css';
import dataLayerPush from '../../../utils/data-layer';

function GestionSearchCompany() {
    const { company, handleChange } = useContext(UserContext);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);
    const navigate = useNavigate();
    const debounceRef = useRef(null);

    const searchPappers = useCallback(async (searchQuery) => {
        if (searchQuery.length < 2) {
            setResults([]);
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(
                `https://suggestions.pappers.fr/v2?q=${encodeURIComponent(searchQuery)}&longueur=10`,
                { headers: { 'api_token': process.env.REACT_APP_PAPPERS_API_KEY } }
            );
            const data = await response.json();
            setResults(data.resultats_nom_entreprise || []);
        } catch (error) {
            console.error('Erreur Pappers:', error);
            setResults([]);
        }
        setLoading(false);
    }, []);

    function handleInputChange(e) {
        const value = e.target.value;
        setQuery(value);
        setSelected(null);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => searchPappers(value), 400);
    }

    function handleSelectCompany(result) {
        setSelected(result);
        setQuery(result.nom_entreprise);
        setResults([]);
        handleChange({ name: 'form.pappers.siren',             value: result.siren || '' });
        handleChange({ name: 'form.pappers.denomination',      value: result.nom_entreprise || '' });
        handleChange({ name: 'form.pappers.forme_juridique',   value: result.forme_juridique || '' });
        handleChange({ name: 'form.pappers.code_naf',          value: result.code_naf || '' });
        handleChange({ name: 'form.pappers.libelle_code_naf',  value: result.libelle_code_naf || '' });
        handleChange({ name: 'form.pappers.siege',             value: result.siege?.adresse_ligne_1 || '' });
        handleChange({ name: 'form.dealname',                  value: result.nom_entreprise || '' });
        handleChange({ name: 'form.legal_statuts',             value: result.forme_juridique || '' });

        // Pré-remplir le prénom et nom si disponibles (entreprises individuelles)
        if (result.prenom) {
            handleChange({ name: 'form.contact.firstname', value: result.prenom.charAt(0).toUpperCase() + result.prenom.slice(1).toLowerCase() });
        }
        if (result.nom) {
            handleChange({ name: 'form.contact.lastname', value: result.nom.charAt(0).toUpperCase() + result.nom.slice(1).toLowerCase() });
        }
    }

    function handleClear() {
        setQuery('');
        setSelected(null);
        setResults([]);
    }

    function handleContinue() {
        if (!selected) return;
        dataLayerPush({ event: 'Clickbutton', eventLabel: 'Gestion - Search Company' });
        navigate('/gestion/contact-informations');
    }

    return (
        <div className="self-step main-1">
            <div className="global">
                <div className="questions">
                    Quel est <span className="important">le nom de votre entreprise</span> ?
                </div>

                <div className={`answers ${styles.answers}`}>
                    {/* ── Champ de recherche ── */}
                    <div className={styles.searchWrapper}>
                        <div className={styles.inputRow}>
                            <span className={styles.searchIcon}>🔍</span>
                            <input
                                type="text"
                                className={styles.searchInput}
                                placeholder="Nom, SIREN, SIRET…"
                                value={query}
                                onChange={handleInputChange}
                                autoFocus
                                autoComplete="off"
                            />
                            {query && (
                                <button
                                    className={styles.clearBtn}
                                    onClick={handleClear}
                                    type="button"
                                    aria-label="Effacer la recherche"
                                >
                                    ✕
                                </button>
                            )}
                        </div>

                        {/* ── Indicateur de chargement ── */}
                        {loading && (
                            <div className={styles.loadingBar}>
                                <span></span><span></span><span></span>
                            </div>
                        )}

                        {/* ── Liste des résultats ── */}
                        {results.length > 0 && (
                            <div className={styles.resultsList}>
                                <div className={styles.resultsHeader}>
                                    {results.length} résultat{results.length > 1 ? 's' : ''}
                                </div>
                                {results.map((result, i) => (
                                    <div
                                        key={i}
                                        className={styles.resultItem}
                                        onClick={() => handleSelectCompany(result)}
                                    >
                                        <div className={styles.resultIcon}>🏢</div>
                                        <div className={styles.resultBody}>
                                            <div className={styles.resultName}>{result.nom_entreprise}</div>
                                            <div className={styles.resultMeta}>
                                                {result.siren && (
                                                    <span className={styles.chip}>SIREN {result.siren}</span>
                                                )}
                                                {result.forme_juridique && (
                                                    <span className={styles.chip}>{result.forme_juridique}</span>
                                                )}
                                                {result.siege?.adresse_ligne_1 && (
                                                    <span className={styles.chipAddr}>
                                                        📍 {result.siege.adresse_ligne_1}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <span className={styles.resultArrow}>›</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* ── Carte entreprise sélectionnée ── */}
                    {selected && (
                        <div className={styles.selectedCard}>
                            <div className={styles.selectedHeader}>
                                <span className={styles.checkIcon}>✅</span>
                                <span className={styles.selectedTitle}>Entreprise sélectionnée</span>
                                <button
                                    className={styles.changeBtn}
                                    onClick={handleClear}
                                    type="button"
                                >
                                    Modifier
                                </button>
                            </div>
                            <div className={styles.selectedGrid}>
                                <Row label="Nom"              value={<strong>{selected.nom_entreprise}</strong>} />
                                {selected.siren             && <Row label="SIREN"            value={selected.siren} />}
                                {selected.forme_juridique   && <Row label="Forme juridique"  value={selected.forme_juridique} />}
                                {selected.code_naf          && (
                                    <Row
                                        label="Code NAF"
                                        value={`${selected.code_naf} – ${selected.libelle_code_naf || ''}`}
                                    />
                                )}
                                {selected.siege?.adresse_ligne_1 && (
                                    <Row label="Siège social" value={selected.siege.adresse_ligne_1} />
                                )}
                            </div>
                        </div>
                    )}

                    {selected && (
                        <div className="cta" onClick={handleContinue}>Continuer →</div>
                    )}
                </div>

                <div className="main-details">
                    <div className="details">
                        🌟 Nous récupérons automatiquement les informations de votre entreprise pour vous simplifier la vie.
                    </div>
                </div>

                <div className="actions">
                    <Link to="/"><div className="prev"><div className="arrow"></div>Retour</div></Link>
                    <div className="next" style={{ display: 'none' }}>Continuer</div>
                </div>
            </div>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className={styles.selectedRow}>
            <span className={styles.rowLabel}>{label}</span>
            <span className={styles.rowValue}>{value}</span>
        </div>
    );
}

export default GestionSearchCompany;
